import axios from "axios";
import qs from 'qs';



let baseUrl = 'https://admin.ginkgoem.cn'; // 测试环境 - dev
let loginBaseUrl = 'https://admin.ginkgoem.cn'; // 测试环境-登录 - dev

//登录页面down地址也要改
//let baseUrl = 'https://api-sales.ichuk.com/api'; // 正式环境 - 生产
//let loginBaseUrl = 'https://api-sales.ichuk.com'; // 正式环境-登录 - 生产



// 自定义判断元素类型
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}


// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

function checkTokenTime() {
  //获取当前时间戳
  let startTime = (new Date).getTime();
  let endTime = localStorage.getItem('tokenExpireTimestamp');
  return difference(startTime, endTime) > 30 * 60 * 1000
}

function checkRefreshTokenTime() {
  //获取当前时间戳
  let startTime = (new Date).getTime();
  let endTime = localStorage.getItem('refreshTokenExpireTimestamp');
  return endTime > startTime
}

// 时间差计算
function difference(srartTime, endTime) {
  var dateDiff = endTime - srartTime; //时间差的毫秒数
  //   console.log("dateDiff", dateDiff);
  return dateDiff;
}

// 时间转换 （几分钟前，几小时前，年月日）



function apiAxios(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,

    // 允许请求的数据在传到服务器之前进行转 把Request PayLoad 转成 Form Data
    transformRequest: [function (params) {
      // return qs.stringify(params, {arrayFormat: 'brackets'});
      return qs.stringify(params)
    }],

    // 自定义的要被发送的头信息
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },

    baseURL: baseUrl,

    //　是否跨域请求
    withCredentials: false
  })

    .then(function (res) {
      // console.log(res,'表单')

      if (res.data.ret == 1) {
        if (success) {
          success(res.data)
        }
      } else {
        if (failure) {
          failure(res.data)
        }
      }

    })
    .catch(function (err) {
      console.log(err, '表单')
    })
}



function apiAxiosJson(method, url, params, success, failure) {
  // console.log("apiAxiosJson", params);
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,

    // 自定义的要被发送的头信息
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'accesstoken': 'Basic aWNodWs6MTIzNDU2'
    },

    baseURL: baseUrl,

    //　是否跨域请求
    withCredentials: false
  })

    .then(function (res) {
      // console.log('json=----',res)
      if (res.data.ret == 1) {
        if (success) {
          success(res.data)
        }
      } else {
        if (failure) {
          failure(res.data)
        }
      }

    })
    .catch(function (err) {
      console.log(err)
    })
}
//登录ajax
function apiLoginAxiosJson(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,

    // 自定义的要被发送的头信息
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'accesstoken': 'Basic aWNodWs6MTIzNDU2'
    },

    baseURL: loginBaseUrl,

    //　是否跨域请求
    withCredentials: false
  })

    .then(function (res) {
      // console.log(res,'json')
      if (res.data.ret == 1) {
        if (success) {
          success(res.data)
        }
      } else {
        if (failure) {
          failure(res.data)
        }
      }

    })
    .catch(function (err) {
      // console.log(err, 'json')
    })
}
//刷新tokrn
function RefeshToken(method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,

    // 自定义的要被发送的头信息
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'accesstoken': 'Basic aWNodWs6MTIzNDU2'
    },

    baseURL: loginBaseUrl,
    async: false,

    //　是否跨域请求
    withCredentials: false
  })

    .then(function (res) {
      // console.log(res,'json')
      if (res.data.ret == 1) {
        if (success) {
          success(res.data)
        }
      } else {
        if (failure) {
          failure(res.data)
        }
      }

    })
    .catch(function (err) {
      // console.log(err, 'json')
    })
}

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // console.log('checkTokenTime()', config.url);
  if (config.url.indexOf('/token') > 0) {
    config.headers['accesstoken'] = 'Basic aWNodWs6MTIzNDU2';
    return config;
  }

  if (checkTokenTime()) {
    // 在发送请求之前做些什么
    config.headers['accesstoken'] = (localStorage.getItem('token') == null ? 'Basic aWNodWs6MTIzNDU2' : localStorage.getItem('token'));
    config.headers['COMPNAYID'] = localStorage.getItem('companyId');
    // // console.log(config)
    return config;
  }

  if (localStorage.getItem('token') == null) {
    
    // debugger
    // if (config.url != '/Home/Login/Login' && config.url != '/Home/Login/register' && config.url != '/Home/ExchangeRate/getList' && config.url != '/Home/Language/getList') {
    //   if (!checkRefreshTokenTime()) {
    //     window.location.href = '/web/login';
    //     localStorage.clear();
    //     return config;
    //   }
    // }
    return config;


  }

  //   refreshToken();
  config.headers['accesstoken'] = (localStorage.getItem('token') == null ? 'Basic aWNodWs6MTIzNDU2' : localStorage.getItem('token'));
  config.headers['COMPNAYID'] = localStorage.getItem('companyId');
  return config;

}, function (error) {
  // debugger
  // 对请求错误做些什么
  return Promise.reject(error);
});



// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // debugger

  // 对响应数据做点什么
  if (response.data.ret == 2) { // 401 登录过期
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = '/login';
  }
  return response;
}, function (error) {
  if (error.response.status == 200) {
    sessionStorage.clear();
    localStorage.clear();
    // window.location.href = '/web/login';
  }
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default {
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  postJson: function (url, params, success, failure) {
    return apiAxiosJson('POST', url, params, success, failure)
  },
  loginPostJson: function (url, params, success, failure) {
    return apiLoginAxiosJson('POST', url, params, success, failure)
  },
  publicGet: function (url, params, success, failure) {
    return apiLoginAxiosJson('GET', url, params, success, failure)
  },
  refeshToken: function (url, params, success, failure) {
    return RefeshToken('POST', url, params, success, failure)
  },
}



// WEBPACK FOOTER //
// ./src/api/network.js